import React from 'react';

interface PriceDownIconProps {
  className?: string;
}

const PriceDownIcon: React.FC<PriceDownIconProps> = ({ className }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_9674_95)">
        <path d="M15.2019 7.01895C14.9898 7.01895 14.7863 7.10324 14.6362 7.25327C14.4862 7.4033 14.4019 7.60678 14.4019 7.81895V9.89095L9.69793 5.18695C9.54804 5.03795 9.34528 4.95432 9.13393 4.95432C8.92258 4.95432 8.71982 5.03795 8.56993 5.18695L5.76193 7.99495L1.36993 3.60295C1.21929 3.45231 1.01497 3.36768 0.801931 3.36768C0.588889 3.36768 0.384573 3.45231 0.233931 3.60295C0.0832876 3.7536 -0.00134277 3.95791 -0.00134277 4.17095C-0.00134277 4.38399 0.0832876 4.58831 0.233931 4.73895L5.19393 9.69895C5.34382 9.84795 5.54658 9.93159 5.75793 9.93159C5.96928 9.93159 6.17204 9.84795 6.32193 9.69895L9.12993 6.89095L13.2659 11.027H11.2019C10.9898 11.027 10.7863 11.1112 10.6362 11.2613C10.4862 11.4113 10.4019 11.6148 10.4019 11.827C10.4019 12.0391 10.4862 12.2426 10.6362 12.3926C10.7863 12.5427 10.9898 12.627 11.2019 12.627H15.2019C15.4141 12.627 15.6176 12.5427 15.7676 12.3926C15.9176 12.2426 16.0019 12.0391 16.0019 11.827V7.82695C16.003 7.72122 15.9831 7.61633 15.9433 7.51835C15.9036 7.42036 15.8449 7.33123 15.7705 7.25609C15.6961 7.18095 15.6075 7.12131 15.5099 7.08061C15.4124 7.0399 15.3077 7.01895 15.2019 7.01895Z" fill="#EC4B2B"/>
      </g>
      <defs>
        <clipPath id="clip0_9674_95">
          <rect width="16" height="16" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default PriceDownIcon;


